export default __webpack_public_path__ + "static/media/mdfnew.d1cdea8b.png";